module.exports = __webpack_public_path__ + "static/media/disabledPreviousIcon.8a186e00.svg";